
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsDiscCouponTypeDaysDialog extends Serenity.EntityDialog<PsDiscCouponTypeDaysRow, any> {
        protected getFormKey() { return PsDiscCouponTypeDaysForm.formKey; }
        protected getIdProperty() { return PsDiscCouponTypeDaysRow.idProperty; }
        protected getLocalTextPrefix() { return PsDiscCouponTypeDaysRow.localTextPrefix; }
        protected getNameProperty() { return PsDiscCouponTypeDaysRow.nameProperty; }
        protected getService() { return PsDiscCouponTypeDaysService.baseUrl; }
        protected getDeletePermission() { return PsDiscCouponTypeDaysRow.deletePermission; }
        protected getInsertPermission() { return PsDiscCouponTypeDaysRow.insertPermission; }
        protected getUpdatePermission() { return PsDiscCouponTypeDaysRow.updatePermission; }

        protected form = new PsDiscCouponTypeDaysForm(this.idPrefix);

    }
}